export default Object.freeze({
  INIT: 0,
  LOADING: 1,
  ERROR: 2,
  LOADED: 3
});
